var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcThread = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.025 3.773a.5.5 0 0 0-1 0v6.787a.5.5 0 0 0 .5.5h7.953l-1.693 1.693a.5.5 0 1 0 .707.707l2.547-2.546a.498.498 0 0 0-.004-.71l-2.543-2.538a.5.5 0 0 0-.706.708l1.69 1.686h-7.45V3.773Z",
  fill: "#222B3E"
})));
export default SvgIcThread;